module.exports = __webpack_public_path__ + "img/img6.8ae86179.png";